<template>
  <div>
    <div class="sayfahead">
      <h1>Teknik Destek Raporu</h1>
    </div>
    <div class="icerik">
    </div>
  </div>
</template>

<script>
export default {
data(){
  return{

  }
}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Raporlama/Teknik.vue